/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeInventoryAuditLogResponse,
  ApiEnvelopeInventoryEmptyDto,
  InventoryAuditGetAuditLogParams,
  InventoryManualAuditEntryRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type inventoryAuditGetAuditLogResponse200 = {
  data: ApiEnvelopeInventoryAuditLogResponse
  status: 200
}

export type inventoryAuditGetAuditLogResponse403 = {
  data: ApiEnvelopeInventoryAuditLogResponse
  status: 403
}

export type inventoryAuditGetAuditLogResponse404 = {
  data: ApiEnvelopeInventoryAuditLogResponse
  status: 404
}

export type inventoryAuditGetAuditLogResponseSuccess = (inventoryAuditGetAuditLogResponse200) & {
  headers: Headers;
};
export type inventoryAuditGetAuditLogResponseError = (inventoryAuditGetAuditLogResponse403 | inventoryAuditGetAuditLogResponse404) & {
  headers: Headers;
};

export type inventoryAuditGetAuditLogResponse = (inventoryAuditGetAuditLogResponseSuccess | inventoryAuditGetAuditLogResponseError)

export const getInventoryAuditGetAuditLogUrl = (id: string,
    params?: InventoryAuditGetAuditLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/storages/${id}/audit-log?${stringifiedParams}` : `/api/inventory/storages/${id}/audit-log`
}

export const useInventoryAuditGetAuditLogHook = (): (id: string,
    params?: InventoryAuditGetAuditLogParams, options?: RequestInit) => Promise<inventoryAuditGetAuditLogResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: InventoryAuditGetAuditLogParams, options?: RequestInit) => {

        return customFetcher(getInventoryAuditGetAuditLogUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryAuditCreateManualAuditEntryResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryAuditCreateManualAuditEntryResponse400 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 400
}

export type inventoryAuditCreateManualAuditEntryResponse403 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 403
}

export type inventoryAuditCreateManualAuditEntryResponse404 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 404
}

export type inventoryAuditCreateManualAuditEntryResponseSuccess = (inventoryAuditCreateManualAuditEntryResponse200) & {
  headers: Headers;
};
export type inventoryAuditCreateManualAuditEntryResponseError = (inventoryAuditCreateManualAuditEntryResponse400 | inventoryAuditCreateManualAuditEntryResponse403 | inventoryAuditCreateManualAuditEntryResponse404) & {
  headers: Headers;
};

export type inventoryAuditCreateManualAuditEntryResponse = (inventoryAuditCreateManualAuditEntryResponseSuccess | inventoryAuditCreateManualAuditEntryResponseError)

export const getInventoryAuditCreateManualAuditEntryUrl = (id: string,) => {




  return `/api/inventory/storages/${id}/audit-log`
}

export const useInventoryAuditCreateManualAuditEntryHook = (): (id: string,
    inventoryManualAuditEntryRequest?: InventoryManualAuditEntryRequest, options?: RequestInit) => Promise<inventoryAuditCreateManualAuditEntryResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryManualAuditEntryRequest?: InventoryManualAuditEntryRequest, options?: RequestInit) => {

        return customFetcher(getInventoryAuditCreateManualAuditEntryUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryManualAuditEntryRequest)
  }
);
      }
  }


